import { i18n } from 'i18n';

export interface CustomReportsPageParams extends Record<string, string | undefined> {
  projectId: string;
  stopeId: string;
}

export const ROUTE_PARAM_IDENTIFIER = ':projectId';
export const STOPE_PARAM_IDENTIFIER = ':stopeId';

export const ROUTE_PATH = `/projects/${ROUTE_PARAM_IDENTIFIER}/overview/stopes/${STOPE_PARAM_IDENTIFIER}/custom-reports`;
export const TITLE = i18n._('Custom Reports');
